import {Box, Grid, Pillar} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithNoMarks} from '../../../../utils'
import type {IntroSectionProps} from '../types'
import styles from '../IntroSection.module.css'

type Props = Pick<IntroSectionProps, 'introPillars'>

export function IntroPillars({introPillars}: Props) {
  if (!introPillars || introPillars.length === 0) return null

  return (
    <Box className={styles.greenBorderBottom}>
      <Grid columnGap="none" className={styles.gridContent}>
        {introPillars.map(item => {
          const IconComponent = item.fields.icon ? getPrimerIcon(item.fields.icon) : null
          return (
            <Grid.Column key={item.sys.id} span={{medium: 4}} className="gridColumn">
              <Box
                className={styles.gridItem}
                padding={{narrow: 24, regular: 40, wide: 64}}
                borderWidth="thin"
                borderColor="muted"
              >
                <Pillar>
                  {IconComponent ? <Pillar.Icon icon={<IconComponent />} /> : null}
                  {item.fields.heading && <Pillar.Heading>{renderWithNoMarks(item.fields.heading)}</Pillar.Heading>}
                  {item.fields.description && (
                    <Pillar.Description>{renderWithNoMarks(item.fields.description)}</Pillar.Description>
                  )}
                </Pillar>
              </Box>
            </Grid.Column>
          )
        })}
      </Grid>
    </Box>
  )
}
